import { AccountObjectFacade } from "../account-object/account-object.facade";
import { DefaultTask } from "./default-task.model";
import { DefaultTaskApiFacade } from "./default-task.api-facade";
import { DefaultTaskStoreFacade } from "./default-task.store-facade";

export class DefaultTaskFacade extends AccountObjectFacade<DefaultTask, DefaultTaskApiFacade, DefaultTaskStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/default-task/default-task.facade.ts